// components/widgets/primitives/misdir-row.js
// ═══════════════════════════════════════════════════════════
// MISDIR ROW — inline row for surfacing things that are not right.
// Severity-tinted left bar + colored severity badge.
// ═══════════════════════════════════════════════════════════
//   high   → terra (alert)
//   medium → amber (warning)
//   low    → steel (note)
// ═══════════════════════════════════════════════════════════

import MetaField from './meta-field';

const SEVERITY_TONES = {
  high:   'terra',
  medium: 'amber',
  low:    'steel',
};

export default function MisdirRow({ item = {}, className = '' }) {
  const tone = SEVERITY_TONES[item.severity] || 'steel';
  return (
    <div className={`ws-prim-misdir ws-prim-misdir-${tone} ${className}`}>
      <div className="ws-prim-misdir-head">
        <span className={`ws-prim-misdir-severity ws-prim-misdir-severity-${tone}`}>
          {item.severity || 'note'}
        </span>
        <span className="ws-prim-misdir-what">{item.what}</span>
      </div>
      {item.source && <MetaField label="source">{item.source}</MetaField>}
      {item.suggested_resolution && (
        <MetaField label="resolution">{item.suggested_resolution}</MetaField>
      )}
    </div>
  );
}
